export default __webpack_public_path__ + "static/media/main-characters-end.5868a5f8.webp";